import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Dialog } from '@material-ui/core'
import ConfirmacionPesadoBruto from './ConfirmacionPesadoBruto'
import { confirmacionChoferCpeEnBruto, updateThemeMode } from '../../../actions'
import DialogoErrorPesado from '../../../components/pesado/DialogoErrorPesado'
import { COLORES } from '../../../../../config/colores'
import PesadoBrutoChoferLectura from './PesadoBrutoChoferLectura'
import RechazadoEnBruto from '../../../components/rechazo/RechazadoEnBruto'

function PesadoBrutoChofer0 (props) {
  const { show, cea, cpe, pesoCabezal, handleSubmit, borrarCpeBruto, onBlurInput, updateShowBruto, pesoMaximo, modo, themeMode } = props
  const [procesando, setProcesando] = useState(true)
  const [cargaRechazada, setCargaRechazada] = useState(false)
  const [motivoRechazo, setMotivoRechazo] = useState(null)
  const [mode, setMode] = useState(themeMode)

  useEffect(() => {
    if (!procesando && cpe && cpe.confirmacionDeChofer && !cpe.calleDeVolcadora) {
      setProcesando(true)
    }

    if (!procesando && cpe && cpe.confirmacionDeChofer && !cpe.calleDeVolcadora) {
      setProcesando(true)
    }

    if (!procesando && !cpe) {
      setProcesando(true)
    }

    if (procesando && cpe && cpe.calleDeVolcadora) {
      setProcesando(false)
    }

    if (procesando && cpe && cea && cea.camion && !cpe.confirmacionDeChofer) {
      setProcesando(false)
    }

    if (!cpe) {
      if (cargaRechazada) {
        setCargaRechazada(false)
      }
    }

    if (cpe && cpe.error) {
      if (cpe.errorDescripcion.startsWith('Rechazo -') && !cargaRechazada) {
        setCargaRechazada(true)
        setProcesando(false)
        if (cpe.errorDescripcion === 'Rechazo - PESOLIMI') {
          setMotivoRechazo('Rechazo en bruto por exceso de peso')
        } else if (cpe.errorDescripcion === 'Rechazo - PESODESA') {
          setMotivoRechazo('Rechazo en bruto por desacuerdo con el peso')
        } else if (cpe.errorDescripcion === 'Rechazo - LIDEMORA') {
          setMotivoRechazo('Rechazo en bruto por superar el tiempo de demora desde el egreso del calado a la balanza')
        }
      }
    }
  }, [props, cargaRechazada, cea, cpe, procesando])

  const handleConfirmacion = (value) => {
    setProcesando(true)
    props.confirmacionChoferCpeEnBruto(cpe.numero, value)
  }

  const submitNumero = (e) => {
    e.preventDefault()
    setProcesando(true)
    handleSubmit()
  }

  const updateTheme = () => {
    if (themeMode === 'dark') {
      setMode('light')
      props.updateThemeMode('light')
    } else {
      setMode('dark')
      props.updateThemeMode('dark')
    }
  }

  return (
    <>
      <div className={`fecha-panel-bruto fecha-panel-bruto-${mode}`}> {props.fecha} </div>
      {cpe && cpe.error && !cargaRechazada
        ? <DialogoErrorPesado
          cpe={cpe}
          borrarCpe={borrarCpeBruto}
          show={(cpe && cpe.error)}
          onBlurInput={onBlurInput}
          updateShowBruto={updateShowBruto}
          showToast={() => null}
          showCancel={false}
        />
        : <></>
      }

      <Dialog
        open={show}
        fullScreen
      >
        {procesando && <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            margin: 'auto'
          }}
        >
          <div className='loader' />
          <h4 style={{ color: COLORES.grey.dark, margin: '15px ' }} >
            Procesando datos
          </h4>
        </div>
        }

        {cpe && cea && cea.camion && !procesando && !cpe.calleDeVolcadora && !cpe.error && <ConfirmacionPesadoBruto
          cpe={cpe}
          cea={cea}
          handleConfirmacion={handleConfirmacion}
          pesoMaximo={pesoMaximo}
          modo={modo}
          pedirConfirmacion={props.pedirConfirmacion}
          rechazarPesado={props.rechazarPesado}
          mode={mode}
          updateTheme={updateTheme}
        />
        }

        {cpe && cpe.error && cargaRechazada && motivoRechazo
          ? <RechazadoEnBruto
            cpe={cpe}
            motivo={motivoRechazo}
            borrarCpe={borrarCpeBruto}
            modo={modo}
          />

          : <></>
        }

        {cpe && cpe.calleDeVolcadora && !cargaRechazada && <div
          style={{
            textAlign: 'center',
            margin: 'auto',
            backgroundColor: '#f7f7f7',
            width: '100%',
            height: '100%'
          }}
        >
          <h1
            className='text-calle-a-descargar'>
                                                Avance por calle
          </h1>
          <h1 className='numero-calle-volcadora'>
            {(cpe.calleDeVolcadora).split('CALLE')}
          </h1>
        </div>
        }
      </Dialog>

      {!cpe && !show
        ? <PesadoBrutoChoferLectura
          pesoCabezal={pesoCabezal}
          modo={modo}
          submitNumero={submitNumero}
          onBlurInput={onBlurInput}
          mode={mode}
          updateTheme={updateTheme}
        />
        : <></>
      }
    </>
  )
}

const mapActionsToProps = {
  confirmacionChoferCpeEnBruto,
  updateThemeMode
}

const mapStateToProps = (state) => ({
  pesoMaximo: state.pesado.pesoMaximo,
  themeMode: state.pesado.themeModeBrutoChofer
})

const withRedux = connect(mapStateToProps, mapActionsToProps)

export default withRedux(PesadoBrutoChofer0)
